import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {EditMetricConversionConfigurationForm} from "./EditMetricConversionConfigurationForm";
import { withTranslation } from 'react-i18next';

class EditMetricConversionConfigurationModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulEdited = this.afterSuccessfulEdited.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulEdited(conversionType, actionIdsSelectedByBuccId) {
        this.toggle();
        this.props.afterSuccessfulEdited(conversionType, actionIdsSelectedByBuccId);
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={"static"}>
                <ModalHeader toggle={this.toggle}>{t('edit_metric_conversion_modal.title')}</ModalHeader>
                <EditMetricConversionConfigurationForm afterSuccessfulEdited={this.afterSuccessfulEdited}
                                                       actionIdsSelectedByBuccId={this.props.actionIdsSelectedByBuccId}
                                                       conversionType={this.props.conversionType}
                                                       adAccountsActionData={this.props.adAccountsActionData}

                />
            </Modal>
        );
    }
}

export const EditMetricConversionConfigurationModal = withTranslation()(EditMetricConversionConfigurationModalClass);
export default EditMetricConversionConfigurationModal;
